<template>
  <div id="SpotOrder">
    <div class="btnBoxs">
<!--      销售单由于有不同友商的产品，不好去筛选出友商的订单产品-->
<!--      <span style="font-size: 0.75rem;">公司名称:</span>-->
<!--      <el-select v-model="companyid" filterable placeholder="请选择" @change="changecompanyid"-->
<!--                 style="width: 85%;margin: 0.625rem 0 0.625rem 0 ;" size='mini'>-->
<!--        <el-option key="index" label="全部" value=""></el-option>-->
<!--        <el-option v-for="(item,index) in companyAll" :key="index" :label="item.name" :value="item.GZL_COMPANY_id_PK">-->
<!--        </el-option>-->
<!--      </el-select>-->

      <!-- <span style="font-size: 0.75rem;">状态:</span>
      <el-select v-model="status" filterable placeholder="请选择" @change="firmstatus"
                 style="width: 85%;margin: 0.625rem 0 0.625rem 0 ;" size='mini'>
        <el-option key="index" label="全部" value=""></el-option>
        <el-option v-for="(item,index) in statusAll" :key="index" :label="item" :value="item">
        </el-option>
      </el-select> -->
      <div class="rightBoxs">
        <el-date-picker v-model="start_end" type="daterange" align="right" unlink-panels range-separator="至"
        start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" format="yyyy 年 MM 月 dd 日"
        value-format="yyyy-MM-dd" style="width: 400px;" size='mini'>
      </el-date-picker>
      <!-- <div class="list">
        <span style="font-size: 0.75rem;">匹配模式:</span>
      <el-select v-model="pattern" filterable placeholder="请选择" style="width: 200px;"
        size='mini'>
        <el-option v-for="(item,index) in patternAll" :key="index" :label="item.label" :value="item.label">
        </el-option>
      </el-select>
      </div> -->
      <div class="list">
        <span style="font-size: 0.75rem;">关键字:</span>
      <el-input v-model="keywords" autocomplete="off" style="width: 200px" size='mini'>
      </el-input>
      </div>
      <el-button type="primary" size='mini'  icon="el-icon-search"  @click="pagefeed(1)" style="margin-left: 30px;">查 询</el-button>
      </div>
    </div>
    <div class="tabs">
      <el-tabs  @tab-click="switchover"  v-model="activeName">
    <el-tab-pane :label="item" :name="item" v-for="(item,index) in statusAll" :key="index"></el-tab-pane>
  </el-tabs>
    </div>
    <el-dialog v-dialogDrag  title="新增现货销售单" :before-close="handleClose" :visible.sync="dlogTableVisible" direction="rtl"
      custom-class="demo-drawer" ref="drawer" width='70%'>
      <div class="demo-drawer__content">
        <div>
          <h2>销售单单头</h2>
          <el-form :model="form" size="mini" :inline="true" label-position="left" :rules="rules" ref="form">
            <el-form-item label="订单编号:" :label-width="formLabelWidth">
              <el-input v-model="form.sale_id" placeholder='请输入内容' style="width: 200px;">
              </el-input>
            </el-form-item>
            <el-form-item label="订货客户:" :label-width="formLabelWidth" prop="customer">
              <el-autocomplete class="inline-input" v-model="form.customer" :fetch-suggestions="querySearch"
                placeholder="请输入内容" style="width: 200px">
              </el-autocomplete>
            </el-form-item>
            <el-form-item label="订货日期:" :label-width="formLabelWidth" required>
              <el-date-picker v-model="form.orderdata" type="date" placeholder="选择日期" format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd" style="width: 200px;">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="交货日期:" :label-width="formLabelWidth">
              <el-date-picker v-model="form.deliverydata" type="date" placeholder="选择日期" format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd" style="width: 200px;">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="总金额:" :label-width="formLabelWidth">
              <el-input v-model="form.totalamount" autocomplete="off" style="width: 200px;" disabled
                placeholder='￥0.000'>
                <template slot="append">人民币</template>
              </el-input>
            </el-form-item>
            <el-form-item label="额外费用:" :label-width="formLabelWidth">
              <el-input type="number" v-model="form.otheramount" autocomplete="off" style="width: 200px"
                @input='changeInt()'>
              </el-input>
            </el-form-item>
            <el-form-item label="运费:" :label-width="formLabelWidth">
              <el-input type="number" v-model="form.freight" autocomplete="off" style="width: 200px"
                @input='changefreight()'>
              </el-input>
            </el-form-item>
            <el-form-item label="吊费:" :label-width="formLabelWidth">
              <el-input type="number" v-model="form.lift_cost" autocomplete="off" style="width: 200px"
                @input='changelift_cost()'>
              </el-input>
            </el-form-item>
            <el-form-item label="应预收款:" :label-width="formLabelWidth">
              <el-input v-model="form.advance" autocomplete="off" style="width: 200px;" placeholder='￥0.000'>
                <template slot="append">人民币</template>
              </el-input>
            </el-form-item>
            <el-form-item label="销售单类别:" :label-width="formLabelWidth">
              <el-select v-model="form.sale_sort" filterable placeholder="请选择" style="width: 200px;" disabled>
                <el-option v-for="(item,index) in marketArr" :key="index" :label="item.options" :value="item.options">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="结算方式:" :label-width="formLabelWidth" required>
              <el-select v-model="form.payment" filterable placeholder="请选择" style="width: 200px;">
                <el-option v-for="(item,index) in payment" :key="index" :label="item.options" :value="item.options">
                </el-option>
              </el-select>
            </el-form-item>
            <img src="../assets/派车送货单.png" alt="" style="width:30px" v-if="pattern1 =='送货'">
            <el-form-item label="收货地址:" :label-width="formLabelWidth" required v-if="pattern =='线上'">
              <el-input v-model="form.address" autocomplete="off" style="width: 200px">
              </el-input>
            </el-form-item>

          </el-form>
          <div class="demo-drawer__footer">
            <el-button size="small" @click="cancelForm2()">取 消 操 作</el-button>
            <el-button size="small" type="primary" @click="upPreserve()" :loading="loading">
              {{
      										loading ? '提交中 ...' : '保 存 销 售 单' }}
            </el-button>
          </div>
        </div>
        <h2>销售单明细列表</h2>
        <el-table highlight-current-row :data="showorder" border style="width: auto" @row-click="handleCurrentChange"
          size="small">
          <el-table-column type="index" label="行号" width="120" :index="indexMethod">
          </el-table-column>
          <el-table-column prop="name" label="材质">
          </el-table-column>
          <el-table-column prop="mold" label="品种">
          </el-table-column>
          <el-table-column prop="spec" label="规格">
          </el-table-column>
          <el-table-column prop="factory" label="厂家">
          </el-table-column>
          <el-table-column prop="warehouse" label="仓库">
          </el-table-column>
          <el-table-column prop="sale_num" label="销售数量">
          </el-table-column>
          <el-table-column prop="delivery_num" label="出库数量">
          </el-table-column>
          <el-table-column prop="cardid" label="卡号">
          </el-table-column>
          <el-table-column prop="sale_price" label="销售单价">
          </el-table-column>
          <el-table-column prop="car" label="车牌号">
          </el-table-column>
          <el-table-column prop="craft_need" label="工艺需求" align="center">
          </el-table-column>
          <el-table-column prop="craft_price" label="工艺加工" align="center">
          </el-table-column>
          <el-table-column prop="cutting_length" label="工艺长度" align="center">
          </el-table-column>
          <el-table-column prop="remark" label="备注">
          </el-table-column>
        </el-table>
        <div>
          <h2>编辑销售单明细</h2>
          <el-form :model="setMsgForm" size="mini" :inline="true" label-position="left" :rules="rules" ref="setMsgForm">
            <el-form-item label="产品ID:" :label-width="formLabelWidth" v-show="false">
              <el-input v-model="setMsgForm.goods_id" autocomplete="off" style="width: 200px">
              </el-input>
            </el-form-item>
            <el-form-item label="材质:" :label-width="formLabelWidth" prop="name">
              <el-autocomplete disabled class="inline-input" v-model="setMsgForm.name" :fetch-suggestions="querySearch2"
                @select="handleSelect2" placeholder="请输入内容" style="width: 200px">
              </el-autocomplete>
            </el-form-item>
            <el-form-item label="规格:" :label-width="formLabelWidth" prop="spec">
              <el-autocomplete disabled class="inline-input" v-model="setMsgForm.spec" :fetch-suggestions="querySearch3"
                @select="handleSelect" placeholder="请输入内容" style="width: 200px">
              </el-autocomplete>
            </el-form-item>
            <el-form-item label="品种:" :label-width="formLabelWidth" prop="mold">
              <el-autocomplete disabled class="inline-input" v-model="setMsgForm.mold" :fetch-suggestions="querySearch4"
                @select="handleSelect" placeholder="请输入内容" style="width: 200px">
              </el-autocomplete>
            </el-form-item>
            <el-form-item label="厂家:" :label-width="formLabelWidth" prop="factory">
              <el-autocomplete disabled class="inline-input" v-model="setMsgForm.factory"
                :fetch-suggestions="querySearch5" @select="handleSelect" placeholder="请输入内容" style="width: 200px">
              </el-autocomplete>
            </el-form-item>
            <el-form-item label="仓库:" :label-width="formLabelWidth" prop="warehouse">
              <el-autocomplete disabled class="inline-input" v-model="setMsgForm.warehouse"
                :fetch-suggestions="querySearch6" @select="handleSelect" placeholder="请输入内容" style="width: 200px">
              </el-autocomplete>
            </el-form-item>
            <el-form-item label="卡号:" :label-width="formLabelWidth" prop="cardid">
              <el-input disabled v-model="setMsgForm.cardid" autocomplete="off" style="width: 200px">
              </el-input>
            </el-form-item>
            <el-form-item label="数量:" :label-width="formLabelWidth" prop="sale_num">
              <el-input v-model="setMsgForm.sale_num" autocomplete="off" style="width: 200px" placeholder="0.000">
                <template slot="append">{{setMsgForm.unit}}</template>
              </el-input>
            </el-form-item>
            <el-form-item label="销售价格:" :label-width="formLabelWidth" prop="sale_price">
              <el-input v-model="setMsgForm.sale_price" autocomplete="off" style="width: 150px" placeholder="0.000">
              </el-input>
              <el-checkbox v-model="setMsgForm.in_tax" label="1" style="width: 50px">
                含税</el-checkbox>
            </el-form-item>
            <el-form-item label="工艺需求:" :label-width="formLabelWidth">
              <el-input v-model="setMsgForm.craft_need" autocomplete="off" style="width: 150px" >
              </el-input>

            </el-form-item>
            <el-form-item label="工艺价格:" :label-width="formLabelWidth">
              <el-input v-model="setMsgForm.craft_price" autocomplete="off" style="width: 150px" placeholder="0.000">
              </el-input>

            </el-form-item>
            <!-- <el-form-item label="运费:" :label-width="formLabelWidth" prop="freight">
              <el-input v-model="setMsgForm.freight" autocomplete="off" style="width: 200px" placeholder="0.000">
              </el-input>
            </el-form-item> -->
            <el-form-item label="计量单位:" :label-width="formLabelWidth">
              <el-select v-model="setMsgForm.unit" placeholder="请选择" style="width: 200px;">
                <el-option v-for="(item,index) in unitArr" :key="index" :label="item.options" :value="item.options">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="基准价格:" :label-width="formLabelWidth">
              <el-input v-model="setMsgForm.base_price" autocomplete="off" style="width: 200px" disabled>
              </el-input>
            </el-form-item>
            <el-form-item label="车牌号:" :label-width="formLabelWidth">
              <el-input v-model="setMsgForm.car" autocomplete="off" style="width: 200px">
              </el-input>
            </el-form-item>
            <el-form-item label="备注:" :label-width="formLabelWidth">
              <el-input v-model="setMsgForm.remark" type="textarea" autosize autocomplete="off" style="width: 200px">
              </el-input>
            </el-form-item>
          </el-form>
          <div class="demo-drawer__footer">
            <!-- <el-button size="small" type="primary" @click="onLoading()">新 增 销 售 明 细</el-button> -->
            <el-button size="small" type="primary" @click="upLoading(setMsgForm)">保 存 销 售 明 细
            </el-button>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog v-dialogDrag :before-close="handleClose" :visible.sync="dlogTableVisibles" direction="rtl"
      custom-class="demo-drawer" ref="drawer" width='70%'>
      <h2>销售单明细列表</h2>
      <el-table highlight-current-row :data="showorder" border style="width: auto" @row-click="handleChange" :key="itemKey"
        size="small">
        <el-table-column type="index" label="行号" :index="indexMethod">
        </el-table-column>
        <el-table-column prop="name" label="材质">
        </el-table-column>
        <el-table-column prop="mold" label="品种">
        </el-table-column>
        <el-table-column prop="spec" label="规格">
        </el-table-column>
        <el-table-column prop="factory" label="厂家">
        </el-table-column>
        <el-table-column prop="warehouse" label="仓库">
        </el-table-column>
        <el-table-column prop="sale_num" label="销售数量">
        </el-table-column>
        <el-table-column prop="delivery_num" label="出库数量">
        </el-table-column>
        <el-table-column prop="cardid" label="卡号">
        </el-table-column>
        <el-table-column prop="sale_price" label="销售单价">
        </el-table-column>
        <el-table-column prop="car" label="车牌号">
        </el-table-column>
        <el-table-column prop="craft_need" label="工艺需求" align="center" width="150">
            <template slot-scope="scope">
             <span v-if="pattern == '线上'"> {{ scope.row.craft_need }}</span>
            <el-button v-if="pattern == '线下' && !!scope.row.craft_need_id" type="primary" size="mini" @click="processing(scope.row)">查看加工单</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="craft_price" label="工艺加工" align="center">
        </el-table-column>
        <el-table-column prop="cutting_length" label="工艺长度" align="center">
        </el-table-column>
        <el-table-column prop="remark" label="备注">
        </el-table-column>
        <el-table-column label="评价信息" width="100" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.Oderevaluate }}
        </template>
        </el-table-column>
      </el-table>
      <!-- <vouCher :seta = "form.SAL_SALE_HEAD_id_PK" :form="form"></vouCher> -->
      <div>
        <h1>订单金额明细</h1>
        <el-table :data="order_prices" border style="width: 100%">
            <!-- <el-table-column type="index" label="行号" width="70" :index="indexMethod">
            </el-table-column> -->
            <el-table-column prop="product_total" label="商品总价" align="center">
            </el-table-column>
            <el-table-column prop="freight_total" label="运费" align="center">
            </el-table-column>
            <el-table-column prop="process_cost" label="工艺加工" align="center">
            </el-table-column>
            <el-table-column prop="credit_discount" label="积分优惠" align="center">
            </el-table-column>
            <el-table-column prop="differ_price_total" label="补差金额" align="center">
            </el-table-column>
            <el-table-column prop="ture_total" label="合计总金额" align="center">
            </el-table-column>
        </el-table>
    </div>
    </el-dialog>
    <el-dialog v-dialogDrag  title="" :visible.sync="dlogTable" width='45%' style="margin-top: 85px;">
      <div align="center" style="color: #F56C6C; font-size: 32px;">
        <h1>出库单已生成!</h1>
        <h1>请勿重复操作!!!</h1>
      </div>
    </el-dialog>
    <el-dialog v-dialogDrag  title="" :visible.sync="dlogTables" width='45%' style="margin-top: 85px;">
      <div align="center" style="color: #F56C6C; font-size: 32px;">
        <h1>用户已付款，请勿修改订单信息!!!</h1>
      </div>
    </el-dialog>
    <el-dialog v-dialogDrag  title="" :visible.sync="dlogTablesis" width='45%' style="margin-top: 85px;">
      <div align="center" style="color: #F56C6C; font-size: 32px;">
        <h1>订单已失效,请用户重新下单!!!</h1>
      </div>
    </el-dialog>
    <!-- 主表格 -->
    <el-table :data="tableData" ref='table' border @selection-change="handleSelectionChange" :height="TableHeight" v-loading="loading"  element-loading-text="拼命加载中">
      <el-table-column type="selection" width="55">
      </el-table-column>table
      <el-table-column prop="SAL_SALE_HEAD_id_PK" label="No." width="60">
      </el-table-column>
      <el-table-column prop="sale_id" label="订单编号" show-overflow-tooltip width="150">
      </el-table-column>
      <el-table-column prop="create_time" label="创建时间" show-overflow-tooltip width="150">
      </el-table-column>
      <el-table-column prop="customer" label="订货客户" show-overflow-tooltip width="200">
      </el-table-column>
      <el-table-column prop="orderdata" label="订货日期" show-overflow-tooltip width="130">
      </el-table-column>
      <el-table-column prop="deliverydata" label="交货日期" show-overflow-tooltip width="130">
      </el-table-column>
      <el-table-column prop="invoice" label="开票资料" @click="detail(row)" :show-overflow-tooltip='true'>
        <template slot-scope="scope">
          <a class="self_peoNum" @click="detail(scope.row);dialogTableVisible=true">{{ scope.row.invoice }}</a>
          <el-dialog v-dialogDrag  :title="form.title" :visible.sync="dialogTableVisible" width='75%' :modal-append-to-body=false>
            <el-form :model="form" size="small" label-position="left" v-for="item in link" :key="item">
              <iframe :src="item" width="100%" height="600px"></iframe>
            </el-form>
          </el-dialog>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="totalamount" label="总金额" >
      </el-table-column> -->
      <el-table-column prop="lift_cost" label="吊费">
      </el-table-column>
      <el-table-column prop="freight" label="运费">
      </el-table-column>
      <el-table-column prop="address" label="地址" v-if="showColumn" width="160">
      </el-table-column>
      <el-table-column prop="discount" label="积分" v-if="showColumn">
      </el-table-column>
      <el-table-column prop="advance" label="应预收款	">
      </el-table-column>
      <el-table-column prop="payment" label="结算方式">
      </el-table-column>
      <el-table-column prop="salesman" label="业务员">
      </el-table-column>
      <!-- <el-table-column prop="name" label="客户名称">
      </el-table-column> -->
      <el-table-column prop="tel" label="客户电话">
      </el-table-column>
      <el-table-column prop="sale_sort" label="类别">
      </el-table-column>
      <el-table-column prop="delivery_sort" label="订单状态">
      </el-table-column>
      <el-table-column prop="is_check" label="状态">
      </el-table-column>
      <el-table-column prop="remark" label="备注" v-if="showColumn">
      </el-table-column>

      <el-table-column fixed="right" label="操作" width="100" align="center">
        <template slot-scope="scope">
          <!-- <el-button @click="handleClick(scope.row)" type="text" size="small">编 辑</el-button> -->
          <el-button @click="handClick(scope.row)" type="text" size="small">明 细</el-button><br>
          <!-- <el-button size="small" type="danger" @click="upfilesss(scope.row)"
            v-if="scope.row.is_invoice ==1 && scope.row.invoice_num !='已开票' && images.length>1">
            提交上传
          </el-button>
          <el-upload class="upload-demo" :action="spotsaleinvoice" :before-upload="beforeAvatarUpload"
            :on-preview="handlePreview" :on-remove="handleRemove" :file-list="fileList" multiple :limit="3">
            <el-button size="small" type="primary" @click="upfile(scope.row)"
              v-if="scope.row.is_invoice ==1 && scope.row.invoice_num !='已开票'">
              <p v-if="scope.row.invoice_num !='已开票'">上传开票</p>
              <p v-else>已开票</p>
            </el-button>
            <el-button size="small" type="primary" @click="upfile(scope.row)" v-if="scope.row.invoice_num =='已开票'"
              disabled>
              <p>已开票</p>
            </el-button>
          </el-upload> -->
          <el-dialog v-dialogDrag  :visible.sync="dialogVisible">
            <!-- <img width="100%" :src="dialogImageUrl" alt=""> -->
            <div style="height:600px">
              <iframe :src="dialogImageUrl" width="100%" height="100%"></iframe>
            </div>
          </el-dialog>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      v-dialogDrag
      :visible.sync="dlogTableVisibles1"
      direction="rtl"
      custom-class="demo-drawer"
      width="70%"
    >
      <div >
        <h3>产品信息</h3>
        <el-table
          :data="newTableData.process_products"
          border
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            prop="SAL_PROCESS_DETAIL_id_PK"
            label="No."
            width="60"
          >
          </el-table-column>
          <el-table-column prop="category" label="品种"> </el-table-column>
          <el-table-column prop="p_name" label="材质"> </el-table-column>
          <el-table-column prop="spec" label="规格"> </el-table-column>
          <el-table-column prop="into_num" label="数量(/吨)"> </el-table-column>
          <el-table-column prop="factory" label="产地"> </el-table-column>
          <el-table-column prop="result_spec" label="成品规格"> </el-table-column>
          <el-table-column prop="cases_num" label="件数"> </el-table-column>
        </el-table>
        <h3 style="margin: 20px 0">工艺及联系人信息</h3>
        <div>
          <el-descriptions direction="horizontal" :column="2" border>
            <el-descriptions-item label="工艺" label-align="center">{{
              require_type
            }}</el-descriptions-item>
            <el-descriptions-item label="工艺过程" label-align="center">{{
              require_type2
            }}</el-descriptions-item>
            <el-descriptions-item
              label="技术要求"
              label-align="center"
              class-name="content-b"
              >{{ require_type3 }}</el-descriptions-item
            >
            <el-descriptions-item label="收货所在地" label-align="center">{{
              newTableData.receive_address
            }}</el-descriptions-item>
            <el-descriptions-item label="原料所在地" label-align="center">{{
              warehouse
            }}</el-descriptions-item>
            <el-descriptions-item label="需求备注" label-align="center">{{
              newTableData.remark
            }}</el-descriptions-item>
            <el-descriptions-item label="开始时间" label-align="center">{{
              newTableData.create_time
            }}</el-descriptions-item>
            <el-descriptions-item label="要求完工日期" label-align="center">{{
              newTableData.complete_time
            }}</el-descriptions-item>
            <el-descriptions-item label="结束时间" label-align="center">{{
              newTableData.update_time
            }}</el-descriptions-item>
            <el-descriptions-item label="联系人" label-align="center">{{
              newTableData.linkman
            }}</el-descriptions-item>
            <el-descriptions-item label="联系方式" label-align="center">{{
              newTableData.linkman_tel
            }}</el-descriptions-item>
               <el-descriptions-item label="客户公司" label-align="center">{{
                newTableData.customer
              }}</el-descriptions-item>
            <el-descriptions-item
              label="查看图纸"
              label-align="center"
              label-class-name="tag"
              class-name="content-b"
            >
              <a
                :href="newTableData.file_link"
                target="_blank"
                rel="noopener noreferrer"
                >{{ newTableData.file_link }}</a
              >
            </el-descriptions-item>
            >
          </el-descriptions>
        </div>
      </div>
    </el-dialog>
    <!-- 分页 -->
    <div class="block">
      <el-pagination class="pagination" @current-change="currentChangeHandle" background :current-page="currentPage1"
        :page-size="pageSize" layout=" prev, pager, next, slot, jumper" :total="currentPage4">
        <span slot style="width: 40px;color: dimgrey">
          <label><input name="Fruit" type="checkbox" value="" v-model="checked" @change='all' />显示全部</label>
        </span>
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {
  spotsale,
  spotproduct,
  spotsaleinvoice,
  saleorderdetails,
  uploadfile, companyoption,appevaluation,singleprocessorder
} from '../../static/API/API.js'
  import {
    publics,
  } from '../js/public.js'
  import {
    is_empty
  } from '../js/examine.js'
  export default {
    components: { //动态组件
    },
    data() {
      var validatesale_price = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入价格'));
        } else if (this.setMsgForm.base_price!=null&&this.setMsgForm.base_price!=undefined&&Number(this.setMsgForm.base_price)!=''&&value <Number(this.setMsgForm.base_price)) {
          callback(new Error('价格不能低于基准价格!'));
        } else {
          callback();
        }

      };
      return {
        //小程序开票信息
        dialogTableVisible: false,
        spotsaleinvoice: spotsaleinvoice,
        link: '',
        // 分页
        currentPage4: 0,
        currentPage1: 1,
        currentPage: 10,
        pageSize: 1,
        keywords: '',
        dlogTableVisibles1:false,
        /* 日期时间*/
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        start_end: '',
        //匹配模式
        pattern: '线上',
        pattern1:'',
        patternAll: [{
          label: '线下'
        }, {
          label: '线上'
        }],
        tableData: [],
        showorder: [],
        order_prices: [],
        //删除
        multipleSelection: [],
        formLabelWidth: '90px',
        //新增
        dlogTableVisible: false,
        //明细
        dlogTableVisibles: false,
        //提示
        dlogTable: false,
        dlogTables: false,
        dlogTablesis: false,
        //保存
        loading: false,
        timer: null,
        form: {},
        setMsgForm: {},
        //必填
        rules: {
          name: [{
            required: true,
            message: '请输入材质名称',
            trigger: ['blur', 'change']
          }],

          mold: [{
            required: true,
            message: '请输入品种名称',
            trigger: ['blur', 'change']
          }],
          factory: [{
            required: true,
            message: '请输入工厂名称',
            trigger: ['blur', 'change']
          }],
          sale_num: [{
            required: true,
            message: '请输入数量',
            trigger: ['blur', 'change']
          }],
          sale_price: [
            { validator: validatesale_price,  trigger: ['blur', 'change'] }
          ],

          warehouse: [{
            required: true,
            message: '请输入仓库名称',
            trigger: ['blur', 'change']
          }],
          s_cardid: [{
            required: true,
            message: '请输入卡号',
            trigger: ['blur', 'change']
          }],
          customer: [{
            required: true,
            message: '请输入订货客户',
            trigger: ['blur', 'change']
          }],
          salesman: [{
            required: true,
            message: '请输入业务员',
            trigger: ['blur', 'change']
          }],
        },
        //判断是否超出库存
        exceed: '',
        //编辑
        SpotsalelistArr: [],
        materialArr: [],
        varietyArr: [],
        standardArr: [],
        factoryArr: [],
        warehouseArr: [],
        optionArr: [],
        customUserArr: [],
        craftArr: [], //工艺
        payment: [], //付款方式
        unitArr: [], //计件单位
        marketArr: [],
        //小程序订单id
        order_id: '',
        // 上传文件
        fileList: [],
        uploadfile: uploadfile,
        dialogVisible: false,
        dialogImageUrl: '',
        images: '',
        // 是否显示全部
        checked: false,
        // 列的配置化对象，存储配置信息
        showColumn: false,
        companyAll:[],
        statusAll:[ '全部','已审核', '已超期', '已取消','补差订单','未确认支付','运费报价中','商品报价','工艺报价中'],
        status:'',
        companyid:'0',
        newNum:'',
        itemKey:'',
        newTableData:[],
        require_type: "",
        require_type2: "",
        require_type3: "",
        warehouse: "",
        activeName:"全部",
        loading:false,
        TableHeight:490
        }
    },
    mounted() { //mounted是vue中的一个钩子函数，一般在初始化页面完成后，再对dom节点进行相关操作
      this.timers()
      this.companyid = sessionStorage.getItem('companyid')
      this.handgetcompanylist()
      this.basicInformation()
      this.pagefeed()
      this.getHeight()
    },
    created () {
    window.addEventListener('resize', this.getHeight)
  },
destroyed () {
    window.removeEventListener('resize', this.getHeight)
  },
    methods: { //函数

      getHeight(){
    //动态计算表格高度
    this.$nextTick(()=>{
      let windowHeight = document.documentElement.clientHeight || document.bodyclientHeight;
    this.TableHeight = windowHeight - 277;//数值"140"根据需要调整
    })
      },
      detail(row) {
        this.link = (row.invoice.substring(row.invoice.length - 1) == ',') ? row.invoice.substring(0, row.invoice
          .length - 1).split(',') : row.invoice.split(',')
        // this.link = row.invoice
      },
      changeInt() {
        this.form.totalamount = 0
        // if (!this.form.otheramount) {
        //   this.form.otheramount = 0;
        // }
        // if (!this.form.freight) {
        //   this.form.freight = 0;
        // }
        this.showorder.forEach(e => {
          // this.form.totalamount = parseFloat(e.sale_num) * parseFloat(e.sale_price) + parseFloat(this.form
          //   .freight) + parseFloat(this.form.otheramount)
          let a = this.form.otheramount ? parseFloat(this.form.otheramount) : 0
          let b = this.form.freight ? parseFloat(this.form.freight) * e.sale_num : 0
          let c = e.craft_price ? parseFloat(e.craft_price) : 0
          let d = this.form.lift_cost ? parseFloat(this.form.lift_cost) * e.sale_num : 0
          this.form.totalamount += parseFloat(e.sale_num) * parseFloat(e.sale_price) +
            a +
            b +
            c +
            d * parseFloat(e.sale_num)
        })
      },
      changefreight() {
        if(this.form.delivery_sort=='自提'&&parseFloat(this.form.freight)>0){
          this.$message({
            type: 'info',
            message: `该订单为自提,请谨慎填写运费！！`,
            duration: 1000,
            showClose: true,
          });
        }
        this.form.totalamount = 0
        this.showorder.forEach(e => {
          let a = this.form.otheramount ? parseFloat(this.form.otheramount) : 0
          let b = this.form.freight ? parseFloat(this.form.freight) * e.sale_num : 0
          let c = e.craft_price ? parseFloat(e.craft_price) : 0
          let d = this.form.lift_cost ? parseFloat(this.form.lift_cost) * e.sale_num : 0
          this.form.totalamount += parseFloat(e.sale_num) * parseFloat(e.sale_price) +
            a +
            b +
            c +
            d * parseFloat(e.sale_num)
        })
      },
      changelift_cost(){
        this.form.totalamount = 0
        this.showorder.forEach(e => {
          console.log(e);
          let a = this.form.otheramount ? parseFloat(this.form.otheramount) : 0
          let b = this.form.freight ? parseFloat(this.form.freight) * e.sale_num : 0
          let c = e.craft_price ? parseFloat(e.craft_price) : 0
          let d = this.form.lift_cost ? parseFloat(this.form.lift_cost) * e.sale_num : 0
          this.form.totalamount += parseFloat(e.sale_num) * parseFloat(e.sale_price) +
            a +
            b +
            c +
            d * parseFloat(e.sale_num)
        })
      },
      timers() {
        let dates = new Date()
        let Year = dates.getFullYear()
        let Month = dates.getMonth() + 1
        let Day = dates.getDate()
        if (Day > 0 && Day < 10) {
          Day = '0' + Day
        }
        if (Month == 1) {
          let startTime = (Year - 1) + '-' + 12 + '-' + Day
          let endTime = Year + '-0' + Month + '-' + Day
          this.SalesTime = Year + '-0' + Month + '-' + Day
          this.start_end = [startTime, endTime]
        } else if (Month > 1 && Month < 10) {
          let startTime = Year + '-0' + (Month - 1) + '-' + Day
          let endTime = Year + '-0' + Month + '-' + Day
          this.SalesTime = Year + '-0' + Month + '-' + Day
          this.start_end = [startTime, endTime]
        } else if (Month == 10) {
          let startTime = Year + '-0' + (Month - 1) + '-' + Day
          let endTime = Year + '-' + Month + '-' + Day
          this.SalesTime = Year + '-' + Month + '-' + Day
          this.start_end = [startTime, endTime]
        } else {
          let startTime = Year + '-' + (Month - 1) + '-' + Day
          let endTime = Year + '-' + Month + '-' + Day
          this.SalesTime = Year + '-' + Month + '-' + Day
          this.start_end = [startTime, endTime]
        }
      },
      // 获取基本的信息
      basicInformation() {
        publics(sessionStorage.getItem('companyid')).then(res => {
          console.log(res);
          this.materialArr = res.materialArr //产品名
          this.varietyArr = res.varietyArr //品种
          this.standardArr = res.standardArr //规格
          this.factoryArr = res.factoryArr //厂家
          this.warehouseArr = res.warehouseArr //仓库
          this.optionArr = res.optionArr //采购类别
          this.customUserArr = res.customUserArr //客户信息
          this.craftArr = res.craftArr //工艺
          this.payment = res.payment //付款方式
          this.unitArr = res.unitArr //计件单位
          this.marketArr = res.marketArr //销售类别
        })
      },
      // 改变当前所在页
      currentChangeHandle(val) {
        this.currentPage1 = val
        this.pagefeed()
      },
      // 监听pageSize文本框的变化，当pageSize为空时，设置pageSize的值为0，以防报错
      all() {
        if (this.checked) {
          this.currentPage = 'all'
          this.pagefeed()
        } else {
          this.currentPage = 10
          this.pagefeed()
        }
      },
      //选择信息
      // 客户信息
      querySearch(queryString, cb) {
        let pickerData = [];
        this.customUserArr.forEach(item => {
          pickerData.push({
            value: item
          });
        });
        var restaurants = pickerData;
        var results = queryString ? restaurants.filter(this.createFilter6(queryString)) : restaurants;
        cb(results);
      },
      handleSelect(item) {
      },
      //材质
      querySearch2(queryString, cb) {
        let pickerData = [];
        this.materialArr.forEach(item => {
          pickerData.push({
            value: item.name
          });
        });
        var restaurants = pickerData;
        var results = queryString ? restaurants.filter(this.createFilter6(queryString)) : restaurants;
        cb(results);
      },
      handleSelect2(item) {
        this.setMsgForm.name = item.value; //材质
      },
      //规格
      querySearch3(queryString, cb) {
        let pickerData = [];
        this.standardArr.forEach(item => {
          pickerData.push({
            value: item.spec
          });
        });
        var restaurants = pickerData;
        var results = queryString ? restaurants.filter(this.createFilter6(queryString)) : restaurants;
        cb(results);
      },
      //品种
      querySearch4(queryString, cb) {
        let pickerData = [];
        this.varietyArr.forEach(item => {
          pickerData.push({
            value: item.category
          });
        });
        var restaurants = pickerData;
        var results = queryString ? restaurants.filter(this.createFilter6(queryString)) : restaurants;
        cb(results);
      },
      //产地
      querySearch5(queryString, cb) {
        let pickerData = [];
        this.factoryArr.forEach(item => {
          pickerData.push({
            value: item.options
          });
        });
        var restaurants = pickerData;
        var results = queryString ? restaurants.filter(this.createFilter6(queryString)) : restaurants;
        cb(results);
      },
      //仓库
      querySearch6(queryString, cb) {
        let pickerData = [];
        this.warehouseArr.forEach(item => {
          pickerData.push({
            value: item.name
          });
        });
        var restaurants = pickerData;
        var results = queryString ? restaurants.filter(this.createFilter6(queryString)) : restaurants;
        cb(results);
      },
      createFilter6(queryString) {
        return (restaurant) => {
          return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) != -1);
        };
      },
      // 查看加工单
      processing(row){
        let params = new URLSearchParams();
        params.append('order_id', row.craft_need_id);
        this.$axios.get(singleprocessorder, {
          params
        }).then(res => {
          // console.log(res);
          this.newTableData = res.data[0]
          if (res.data[0].process_products.length > 0) {
        this.warehouse = res.data[0].process_products[0].warehouse;
      }
      let name = "";
      res.data[0].process_details.forEach((item) => {
        if (item.require_type == "工艺") {
          this.require_type = item.name;
        }
        if (item.require_type == "工艺过程") {
          this.require_type2 = item.name;
        }
        if (item.require_type == "技术要求") {
          name += " " + item.name;
          if (!!item.require_info || !!item.unit) {
            name += " " + item.require_info;
            name += " " + item.unit;
          }
          this.require_type3 = name;
        }
      });
          this.dlogTableVisibles1 = true
        })
      },
      pagefeed(e) {
        this.loading = true
        let start_end = this.start_end
        let params = new URLSearchParams();
        params.append('sale_type', '现货')
        params.append('sale_sort', this.pattern)
        params.append('start_time', start_end[0]);
        params.append('end_time', start_end[1]);
        if (e) {
          params.append('page_number', 1)
        } else {
          params.append('page_number', this.currentPage1)
        }
        params.append('page_size', this.currentPage)
        params.append('keyword', this.keywords);
        params.append('status', this.status);
        this.$axios.get(spotsale, {
          params
        }).then(res => {
          this.currentPage4 = Number(res.data[0]['PageNums'])
          this.tableData = res.data[0]['pagedata']
          this.$nextTick(() => {
            this.$refs['table'].doLayout()
          })
          setTimeout(() => {
            this.loading = false
          }, 300);
        })
      },
      //设置数据
      setData() {
        this.setMsgForm = {}
      },
      //新增采购订单
      handleCurrentChange(val) {
        console.log(val);
        this.currentRow = val;
        // this.form.totalamount = this.currentRow.s_price
        if (this.currentRow.is_delivery == 1) {
          this.dlogTable = true
        } else {
          this.setMsgForm = Object.assign({}, this.currentRow)
          this.newNum = val.sale_num
        }
      },
      //明细表
      handleChange(val) {
        this.currentRow = val;
        this.setMsgForm = Object.assign({}, this.currentRow)
      },
      handleClose(done) {
        this.$confirm('确定要离开本页面么？', '确认信息', {
            distinguishCancelAndClose: true,
            confirmButtonText: '离开',
            cancelButtonText: '取消'
          })
          .then(_ => {
            this.dlogTableVisibles = false
            this.dlogTableVisible = false;
          })
          .catch(_ => {
            this.$message({
              type: 'info',
              message: '已取消',
              duration: 1000,
            showClose: true,
            });
          });
      },
      //自动生成行号
      indexMethod(index) {
        return index + 1;
      },
      //删除
      handleSelectionChange(val) {
        this.multipleSelection = val;
        // 获取明细判断是否可进行删除
        this.multipleSelection.forEach(e => {
          let params = new URLSearchParams();
          params.append('ope_type', '单头明细');
          params.append('head_id', e.SAL_SALE_HEAD_id_PK);
          params.append('companyid', this.companyid);
          this.$axios.get(spotsale, {
            params
          }).then(res => {
            this.showorder = res.data
          });
        })
      },
      delClick() { //删除
        let head_id = ''
        let changeTF = []
        this.multipleSelection.map(e => {
          head_id += e.SAL_SALE_HEAD_id_PK + ','
        })
        this.showorder.forEach(item => {
          changeTF.push(item.is_delivery)
        })
        let idIn = changeTF.some(e => Object.is(e, "已出库"))
        if (idIn) {
          this.$alert('订单已出库！', {
            confirmButtonText: '确定',
            callback: action => {
              this.$message({
                type: 'info',
                message: `订单已出库，无法删除销售单！`,
                duration: 1000,
            showClose: true,
              });
              this.pagefeed()
            }
          });
        } else {
          let params = new URLSearchParams()
          params.append('ope_type', '删除')
          params.append('user_id', sessionStorage.getItem('user_id'))
          params.append('head_id', head_id)
          this.$axios.post(spotsale, params).then(res => {
            this.$alert(res.data, {
              confirmButtonText: '确定',
              callback: action => {
                this.$message({
                  type: 'info',
                  message: res.data,
                  duration: 1000,
            showClose: true,
                });
                this.pagefeed()
              }
            });
          })
        }
      },
      //编辑
      handleClick(row) {
        this.pattern1 = row.delivery_sort
        if((row.is_check == '财务审核' || row.is_check == '待审核') && row.sale_sort == '线上'){
          this.dlogTables = true
        } else if(row.is_check == '已超期' || row.is_check == '已取消'){
          this.dlogTablesis = true
        } else{
          this.form = row
          let params = new URLSearchParams();
          params.append('ope_type', '单头明细');
          params.append('head_id', row.SAL_SALE_HEAD_id_PK);
          params.append('companyid', this.companyid);
          this.$axios.get(spotsale, {
            params
          }).then(res => {
            console.log(res);
            this.showorder = res.data
            res.data.forEach(e => {
              if (e.is_delivery != '已出库' && e.is_delivery != '待出库') {
                this.dlogTableVisible = true
              } else {
                this.dlogTable = true
              }
            })
          });
        }
      },
      //明细
      handClick(row) {
        console.log(row);
        this.order_prices = []
        this.form = row
        let params = new URLSearchParams();
        params.append('head_id', row.SAL_SALE_HEAD_id_PK);
        this.$axios.get(saleorderdetails, {
          params
        }).then(res => {
          console.log(res);
        this.showorder = res.data.details
        this.order_prices.push(res.data.order_prices)
        let params = new URLSearchParams();
        params.append('order_num', row.sale_id);
        this.$axios.get(appevaluation, {
          params
        }).then(res => {
          if(res.data.length > 0){
            this.showorder[0]['Oderevaluate'] = res.data[0].evaluation
            this.itemKey = Math.random()
          }
        });
        this.dlogTableVisibles = true
        });
        // this.getOderevaluate(row.SAL_SALE_HEAD_id_PK)

      },
      // before-upload上传文件之前的钩子 -- 限制文件大小
      beforeAvatarUpload(file) {
        let _this = this
        let fd = new FormData();
        fd.append('file', file); //传文件
        this.$axios.post(uploadfile, fd).then(function(res) {
          _this.images += res.data + ','
        })
      },
      // 删除图片
      handleRemove(file, fileList) {
        this.imageArr = ''
      },
      handlePreview(file) {
        this.dialogVisible = true
        this.dialogImageUrl = file.response
      },
      //上传开票
      upfile(row) {
        this.order_id = row.SAL_SALE_HEAD_id_PK
        row.images = ''
      },
      upfilesss(row) {
        let _this = this
        let formData = new FormData();
        formData.append('file', _this.images); //传文件
        formData.append('ope_type', '上传模板')
        formData.append('order_id', this.order_id)
        this.$axios.post(spotsaleinvoice, formData).then(function(res) {
          _this.$alert(res.data, {
            confirmButtonText: '确定',
            callback: action => {
              _this.$message({
                type: 'info',
                message: res.data,
                duration: 1000,
            showClose: true,
              });
              _this.pagefeed()
            }
          });
        })
      },
      cancelForm2() {
        this.loading = false;
        this.dlogTableVisible = false;
        this.setMsgForm = {}
        clearTimeout(this.timer);
        // location.reload()
      },
      upPreserve() { //保存销售单
        let form = this.form
        if (is_empty(form.customer, form.orderdata, form.sale_sort, this.exceed)) { //判断是否没填数据
          this.timer = setTimeout(() => {
            // 动画关闭需要一定的时间
            setTimeout(() => {
              this.loading = false;
            }, 400);
          }, 1000);
          this.$alert('现货销售单头生成失败！请您认真核对单头信息和销售明细！', {
            confirmButtonText: '确定',
            callback: action => {
              this.$message({
                type: 'info',
                message: `请完善现货销售订单单头,检查是否保存销售明细！`,
                duration: 1000,
            showClose: true,
              });
            }
          });
          return false
        } else {
          if (this.form.is_check == "已审核"||this.form.is_check == "财务审核") { //this.showColumn
            this.form.is_check = '待审核'
          }
          if (this.form.is_check == "已拒绝" && this.form.sale_sort == "线下") { //this.showColumn
            this.form.is_check = '待审核'
          }
          // if (form.discount) {
          //   this.form.totalamount = this.form.totalamount - (Number(this.form.discount) * 10)
          // }
          let params = new URLSearchParams();
          params.append('ope_type', '修改')
          params.append('user_id', sessionStorage.getItem('user_id'))
          params.append('head', JSON.stringify(this.form))
          params.append('body', JSON.stringify(this.showorder))
          this.$axios.post(spotsale, params).then(res => { //新保存的数据
            this.timer = setTimeout(() => {
              // 动画关闭需要一定的时间
              setTimeout(() => {
                this.loading = false;
                this.$alert(res.data, {
                  confirmButtonText: '确定',
                  callback: action => {
                    this.$message({
                      type: 'info',
                      message: res.data,
                      duration: 1000,
            showClose: true,
                    });
                    this.dlogTableVisible = false
                    this.pagefeed()
                  }
                });
              }, 400);
            }, 1000);
          })
        }
      },
      upLoading(val) { //保存销售细明 可以为空 可以有基准价格 （Number(this.setMsgForm.base_price) =='' || val.sale_price >= Number(this.setMsgForm.base_price）
      console.log('34234');
      console.log(this.setMsgForm.base_price,'this.setMsgForm.base_price');
        if (this.setMsgForm.goods_id && (this.setMsgForm.base_price!=null&&this.setMsgForm.base_price!=undefined&&Number(this.setMsgForm.base_price)==''||val.sale_price >= Number(this.setMsgForm.base_price))) {

          // this.showorder = [this.setMsgForm]
          let Temp = Object.assign([], this.showorder)
          let Tempa = Object.assign([], this.showorder)
          Temp.forEach((value, index, array) => {
            if (Object.is(this.setMsgForm.SAL_SALE_DETAIL_id_PK, value.SAL_SALE_DETAIL_id_PK)) {
              array[index] = this.setMsgForm
            }
          })
          console.log(Temp);
          // console.log(this.setMsgForm.sale_num);
          this.showorder = Temp
          this.showorder.forEach((e, index) => {
            console.log(e.goods_id);
            e.sale_head = this.form.SAL_SALE_HEAD_id_PK
            let params = new URLSearchParams();
            params.append('goods_id', e.goods_id);
            params.append('show_type', 'single');
            this.$axios.get(spotproduct, {
              params
            }).then((res) => {
              console.log(res.data[0].canstock);
              console.log(this.newNum);
              let SpotNum = 0
              if (this.form.is_check != '已拒绝') {
                SpotNum = Number(res.data[0].canstock) + Number(this.newNum)
              } else {
                SpotNum = Number(res.data[0].canstock)
              }
              console.log(SpotNum);
              console.log(Number(e.sale_num));
              // 判断产品可用库存加上已分配库存  是否大于现实库存
              if (SpotNum < Number(e.sale_num)) {
                this.setMsgForm.sale_num = ''
                this.$alert("产品"+e.name+"("+e.spec+')修改后数量超出现有库存！', {
                  confirmButtonText: '确定',
                  callback: action => {
                    this.$message({
                      type: 'info',
                      message: `请检查修改后的数量！`,
                      duration: 1000,
                      showClose: true,
                    });
                  }
                });
              } else {
                this.changefreight()
                // let a = this.form.otheramount ? parseFloat(this.form.otheramount) : 0
                // let b = this.form.freight ? parseFloat(this.form.freight) : 0
                // let c = e.craft_price ? parseFloat(e.craft_price) : 0
                // this.form.totalamount = parseFloat(e.sale_num) * parseFloat(e.sale_price) +
                //   a +
                //   b +
                //   c * parseFloat(e.sale_num)
                // if (this.form.otheramount && !this.form.freight) {
                //   this.form.totalamount = parseFloat(e.sale_num) * parseFloat(e.sale_price) + parseFloat(this
                //     .form.otheramount)
                // } else if (!this.form.otheramount && this.form.freight) {
                //   this.form.totalamount = parseFloat(e.sale_num) * parseFloat(e.sale_price) + parseFloat(this
                //     .form.freight)
                // } else if (this.form.otheramount && this.form.freight) {
                //   this.form.totalamount = parseFloat(e.sale_num) * parseFloat(e.sale_price) + parseFloat(this
                //     .form.freight) + parseFloat(this.form.otheramount)
                // }
                this.exceed = "成功"
                if (this.form.discount) {
                this.form.totalamount = this.setMsgForm.sale_price - (Number(this.form.discount) * 10)
              }
              }
            })
          })
        }else{
          this.$alert("销售价格不能低于基准价格,请重新输入销售价格~", {
              confirmButtonText: '确定',
              callback: action => {
                this.$message({
                  type: 'info',
                  message: `请检查修改后的数量！`,
                  duration: 1000,
                  showClose: true,
                });
              }
            });
            this.setMsgForm.sale_price = 0
        }
      },
      handgetcompanylist(){
        let params = new URLSearchParams();
        this.$axios.get(companyoption, {
          params
        }).then((res) => {
          this.companyAll = res.data
          this.companyid =0

        })
      },
    changecompanyid(val){
      this.companyid=val
      this.pagefeed(1)
    },
      firmstatus(val){
        this.status=val
        this.pagefeed(1)
      },
      switchover(tab, event) {
        console.log(tab.name);
        if(tab.name == '全部'){
          this.status = ''
        }else{
          this.status = tab.name
        }
        this.pagefeed()
      }
    },
    computed: { //计算属性

    },
    watch: { //监测Vue实例上的数据变动
      pattern: function() {
        this.$nextTick(() => {
          this.$refs['table'].doLayout()
          // console.log(this.$refs.table.doLayout());
        })
        if (this.pattern == '线上') {
          this.showColumn = true
        } else {
          this.showColumn = false
        }
      }
    }
  }
</script>

<style scoped>
.btnBoxs{
  display: flex;
  justify-content: space-between;
}
.rightBoxs{
  display: flex;
}
.rightBoxs .list{
  margin-left: 50px;
}
.tabs{
  margin-bottom: 20px;
  margin-top: 10px;
}
/deep/ .el-tabs__item {
  font-size: 15px;
  font-weight: bold;
}
/* /deep/ .el-table .el-table__body{
  height: 100%;
} */
</style>



// WEBPACK FOOTER //
// src/views/SpotOrder.vue